import CalloutRepository from "../CalloutRepository"

export default class ResourcesCallout extends CalloutRepository {
    static schemaId = "resource_callout"

    constructor() {
        super(ResourcesCallout.schemaId)
    }
}
